import { gql } from '@apollo/client'

// Minimal query for the page-wrapper breadcrumb. Resolves from the Apollo cache
// once CUSTOMER_DETAIL_QUERY has loaded the same Customer (normalized by id).
export const CUSTOMER_NAME_QUERY = gql`
  query CustomerName($customerNo: String!) {
    customer(customerNo: $customerNo) {
      id
      customerNo
      fullName
      companies {
        id
        name
      }
    }
  }
`

// Single-customer detail for the CRM Customer Detail dashboard. The `customer`
// query keys on customerNo (the route :id everywhere). `performance` already
// carries wallet/CLV/revenue/days; `orders` + `ticketsConnection` back the
// overview tables; projects, outstanding, and the activity feed are derived on
// the client from `orders[].companyProject` (see CustomerInfo).
export const CUSTOMER_DETAIL_QUERY = gql`
  query CustomerDetail($customerNo: String!) {
    customer(customerNo: $customerNo) {
      id
      customerNo
      fullName
      firstName
      roleName
      email
      phoneNumber
      lineId
      lineUrl
      companies {
        id
        name
      }
      personalAssistant {
        id
        fullName
      }
      performance {
        id
        clvSegment
        predictedClvSatangs
        historicalRevenueClvSatangs
        walletBalanceSatangs
        daysSinceLastOrder
        totalOrderCount
        projectCount
        lastPaidAt
      }
      orders {
        id
        number
        state
        stateLabel
        selfPickup
        scmFirstName
        createdAt {
          raw
          shortDate
        }
        grandTotal {
          value
        }
        cses {
          id
          firstName
        }
        sales {
          id
          firstName
        }
        logistics {
          id
          firstName
        }
        orderShippingAddress {
          id
          postalCode
          district {
            id
            name
          }
          province {
            id
            name
          }
        }
        companyProject {
          id
          name
          status
          paidPrice {
            value
          }
          unpaidPrice {
            value
          }
        }
        boqs {
          totalCount
          nodes {
            id
            boqContext
            createdAt {
              raw
              shortDate
            }
            boqFiles {
              totalCount
            }
          }
        }
      }
      ticketsConnection(first: 20) {
        totalCount
        nodes {
          id
          ticketNo
          categoryTypeLabel
          description
          state
          stateLabel
          createdAt {
            shortDate
          }
          updatedAt {
            shortDate
          }
          lastTicketNoteAnswer {
            note
          }
        }
      }
    }
  }
`
